import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {AppLayoutComponent} from './layout/app.layout.component';
import {WexinMiniProgramModule} from "./pages/user/wexin_mini_program/wexin_mini_program.module";
import {ProductListModule} from "./pages/product/product_list/product_list.module";
import {ProductTagComponent} from "./pages/product_tag/product_tag.component";
import {ProductTagModule} from "./pages/product_tag/product_tag.module";
import {OrderListModule} from "./pages/order/order_list/order_list.module";

const routes: Routes = [
  {
    path: '', component: AppLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule),
        data: {animationName: '/'}
      },
      {
        path: 'product/my',
        loadChildren: () => import('./pages/product/product_list/product_list.module').then(m => m.ProductListModule),
        data: {animationName: '/product/my'}
      },
      {
        path: 'product/add',
        loadChildren: () => import('./pages/product/add_product/add_product.module').then(m => m.AddProductModule),
        data: {animationName: 'product/add'}
      },
      {
        path: 'product_tag',
        loadChildren: () => import('./pages/product_tag/product_tag.module').then(m => m.ProductTagModule),
        data: {animationName: 'product_tag'}
      },
      {
        path: 'order/my',
        loadChildren: () => import('./pages/order/order_list/order_list.module').then(m => m.OrderListModule),
        data: {animationName: 'order/my'}
      },
      {
        path: 'setting',
        loadChildren: () => import('./pages/user/setting/setting.module').then(m => m.SettingModule),
        data: {animationName: 'setting'}
      },
      {
        path: 'message',
        loadChildren: () => import('./pages/user/message/message.module').then(m => m.MessageModule),
        data: {animationName: 'message'}
      }
    ]
  },
  {path: 'login', loadChildren: () => import('./pages/user/login2/login2.module').then(m => m.Login2Module)},
  {path: 'login2', loadChildren: () => import('./pages/user/login/login.module').then(m => m.LoginModule)},
  {path: 'register', loadChildren: () => import('./pages/user/register/register.module').then(m => m.RegisterModule)},
  {path: 'weixin_login', loadChildren: () => import('./pages/user/weixin_login/weixin_login.module').then(m => m.WeixinLoginModule)},
  {path: 'sub_account_callback', loadChildren: () => import('./pages/user/sub_account_callback/sub_account_callback.module').then(m => m.SubAccountCallbackModule)},
  {path: 'wexin_mini_program', loadChildren: () => import('./pages/user/wexin_mini_program/wexin_mini_program.module').then(m => m.WexinMiniProgramModule)}
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
